export enum MONGO_REALM_COLLECTIONS {
  ACCOUNTS = 'accounts',
  ACCOUNT_REVENUE = 'accountRevenue',
  ADDRESSES = 'addresses',
  ADDRESS_REVENUE = 'addressRevenue',
  CATEGORIES = 'categories',
  CATEGORY_TREE = 'categoryTree',
  ORDERS = 'orders',
  PRODUCTS = 'products',
  QUOTES = 'quotes',
  RECEIPT_CALENDAR = 'receiptCalendar',
  USERS = 'users',
  PROMOTIONS = 'promotions',
  VETSUITE_OVERVIEW = 'vetsuiteoverview',
  VETSUITE_TRANSACTIONS = 'vetsuitetransactions',
  DIGITAL_SHWOROOM_ANALYTICS = 'ds-analytics'
}

export enum MONGO_REALM_DBS {
  TEST = 'test',
  COVETRUS_DEVELOPMENT = 'covetrus-development'
}
